import React from 'react';
import styled, { withTheme }  from 'styled-components/macro'

const Container = styled.div`
  width: 100%;
  height: 100%;
`

const SVG = styled.svg`
  width: 100%;
  height: 100%;
`

const Glyph = ({renderAsSvg, path, size, pos, theme}) => {
  let {width, height} = size;

  if(renderAsSvg){
    return (
      <Container>
        <SVG width={width} height={height}>
          { path(width,height).map( (path,i) => {
            return <path key={i} d={path.d} strokeWidth={path.strokeWidth} stroke={theme.color} fill={'none'} />
          })}
        </SVG>
      </Container>
    )
  }
  return (
    <g transform={`translate(${pos.x} ${pos.y})`} width={width} height={height}>
      { path(width,height).map( (path,i) => {
        return <path key={i} d={path.d} strokeWidth={path.strokeWidth} stroke={theme.color}  fill={'none'} />
      })}
    </g>
  )
}

export default withTheme(Glyph);
